<template>
  <v-dialog :value="value" max-width="1200px" @input="handleDialogInput">
    <v-card class="config-diff-card">
      <v-card-title>
        <p class="headline">Comparação de alterações</p>
        <div style="text-align: right; margin-left: auto">
          <p>
            Alterado por <b>{{ userName || "--" }}</b>
          </p>
          <p>em {{ createdAt | formatDateTime }}</p>
        </div>
      </v-card-title>

      <v-divider />

      <v-card-text class="config-diff-content">
        <div ref="mergeContainer" class="config-diff-view" />
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn flat color="primary" @click="closeDialog">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { MergeView } from "@codemirror/merge";
import { EditorView } from "@codemirror/view";

export default {
  name: "DialogConfigDiff",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    currentConfig: {
      type: [Object, Array, String, Number, Boolean],
      default: null,
    },
    previousConfig: {
      type: [Object, Array, String, Number, Boolean],
      default: null,
    },
    createdAt: {
      type: String,
      default: "",
    },
    userName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      mergeViewInstance: null,
    };
  },
  watch: {
    value(isOpen) {
      if (!isOpen) {
        this.destroyMergeView();
        return;
      }
      this.$nextTick(() => {
        this.initializeMergeView();
      });
    },
    currentConfig() {
      if (!this.value) {
        return;
      }
      this.$nextTick(() => {
        this.initializeMergeView();
      });
    },
    previousConfig() {
      if (!this.value) {
        return;
      }
      this.$nextTick(() => {
        this.initializeMergeView();
      });
    },
  },
  beforeDestroy() {
    this.destroyMergeView();
  },
  methods: {
    closeDialog() {
      this.$emit("input", false);
      this.$emit("close");
    },
    handleDialogInput(isOpen) {
      this.$emit("input", isOpen);
      if (!isOpen) {
        this.$emit("close");
      }
    },
    initializeMergeView() {
      if (!this.$refs.mergeContainer) {
        return;
      }

      this.destroyMergeView();
      this.$refs.mergeContainer.innerHTML = "";

      const previousDoc = this.stringifyConfig(this.previousConfig);
      const currentDoc = this.stringifyConfig(this.currentConfig);

      this.mergeViewInstance = new MergeView({
        a: {
          doc: previousDoc,
          extensions: [EditorView.editable.of(false)],
        },
        b: {
          doc: currentDoc,
          extensions: [EditorView.editable.of(false)],
        },
        parent: this.$refs.mergeContainer,
        gutter: true,
        highlightChanges: true,
        collapseUnchanged: {
          margin: 6,
          minSize: 6,
        },
      });
    },
    destroyMergeView() {
      if (!this.mergeViewInstance) {
        return;
      }
      this.mergeViewInstance.destroy();
      this.mergeViewInstance = null;
    },
    stringifyConfig(config) {
      if (config === null || typeof config === "undefined") {
        return "{}";
      }
      if (typeof config === "string") {
        try {
          return JSON.stringify(JSON.parse(config), null, 2);
        } catch (error) {
          return config;
        }
      }
      try {
        return JSON.stringify(config, null, 2);
      } catch (error) {
        return "{}";
      }
    },
  },
};
</script>

<style scoped>
.config-diff-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 90vh;
}

.config-diff-content {
  flex: 1;
  overflow-y: auto;
}

.config-diff-view {
  min-height: fit-content;
  overflow: auto;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}
</style>
